/*
 * The numbers on the contact page. `href` is what the tel:/mailto: link uses —
 * a parent on a phone should be one tap from the office, not copying digits.
 */
export const contactLines = [
  {
    value: '0800 114 2255',
    href: 'tel:08001142255',
    detail: 'main office, 8:00–17:00',
  },
  {
    value: '0803 441 9820',
    href: 'tel:08034419820',
    detail: 'admissions, Mrs. Adeyemi',
  },
  { value: 'hello@toddlersacademy.sch', href: 'mailto:hello@toddlersacademy.sch' },
  {
    value: 'admissions@toddlersacademy.sch',
    href: 'mailto:admissions@toddlersacademy.sch',
  },
];

export const schoolHours = [
  { label: 'Gate opens', time: '7:30' },
  { label: 'Lessons begin', time: '8:30' },
  { label: 'Toddler pick-up', time: '13:00' },
  { label: 'End of day', time: '15:15' },
  { label: 'After-school club until', time: '17:00' },
];
